/**
 * This file includes constants that are to be used in multiple places in the project
 */

export const PLATFORM_STORAGE_KEY = "X-Platform-Key" as const;

export const WHITE_MWS_LOGO_URL =
  "https://mwsprod.imgix.net/imgix/assets/logos/MWS+White.svg" as const;

export const BLACK_MWS_LOGO_URL =
  "https://mwsprod.imgix.net/imgix/assets/logos/MWS.svg" as const;

export const BLACK_FABRICKS_LOGO =
  "https://matchwornshirt.imgix.net/fabricks_logo_black.png" as const;

export const MOCKUP_IMAGE_LABELS = [
  "FrontWithSleevesImage",
  "FrontNoSleevesImage",
  "BackWithSleevesImage",
  "BackNoSleevesImage",
] as const;

export const EURO_CODE = "EUR" as const;

export const ELASTIC_SEARCH_WAIT_TIME = 1000 as const;

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000" as const;
